import { Navigate, useParams } from "react-router-dom";
import { LinksActivate } from "./links-activate";
import { useLinksPlacements } from "./links-queries";

export function LinksIndex() {
    const { accountID, showID } = useParams();
    const query = useLinksPlacements(accountID, showID);

    if (!query.data) return;

    if (query.data?.results.length) return <Navigate to="reports" replace />;

    return <LinksActivate />;
}
